/*
 *
 * ManageStructurePopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 29-Jan-2025
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ManageStructurePopup from './ManageStructurePopup'
import * as actionLayer from '../../modules/TerminalsManagementActions'
import { doPopup } from 'Store/actions/popup'
//import * as formikActions from 'Store/actions/formik'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(actionLayer, dispatch),
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  data: state?.TerminalsManagement?.structureDetails || {},
  isLoading: state.loading?.local_modifyStructureLoader || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ManageStructurePopup)
